import dayjs from 'dayjs';

export const getDuration = (startTime, endTime) => {
  const differenceInMilliseconds = dayjs(endTime).diff(dayjs(startTime));
  const duration = dayjs.duration(differenceInMilliseconds);
  const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
  const minutes = String(duration.minutes()).padStart(2, '0');
  const seconds = String(duration.seconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const getDurationWithMs = (timeInMs) => {
  if (timeInMs) {
    const duration = dayjs.duration(timeInMs);
    const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
  return '--:--:--';
};

export const calculateDuration = (
  startTime: string | null,
  endTime: string | null
): string => {
  if (!startTime || !endTime) {
    return '--:--:--';
  }

  const start = new Date(startTime);
  const end = new Date(endTime);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return '--:--:--';
  }

  const durationInMs = end.getTime() - start.getTime();
  const durationInSeconds = Math.floor(durationInMs / 1000);

  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = durationInSeconds % 60;

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatTime = (time) => {
  if (time) {
    const msTime = dayjs.duration(time);
    const hours = String(Math.floor(msTime.asHours())).padStart(2, '0');
    const minutes = String(msTime.minutes()).padStart(2, '0');
    const seconds = String(msTime.seconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
  return '--:--:--';
};

export const convertSecondsToMinSec = (seconds) => {
  if (seconds < 60) {
    return Math.round(seconds) + ' sec';
  } else {
    return (seconds / 60).toFixed() + ' min';
  }
};

export function formatFilterDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
  const timezoneOffset = -date.getTimezoneOffset();
  const timezoneHours = Math.floor(timezoneOffset / 60);
  const timezoneMinutes = Math.abs(timezoneOffset % 60);
  const timezoneString = `${timezoneOffset >= 0 ? '+' : '-'}${String(
    timezoneHours
  ).padStart(2, '0')}:${String(timezoneMinutes).padStart(2, '0')}`;

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneString}`;
}
